
// Layout constants for consistent spacing and dimensions across the app
export const LAYOUT_CONSTANTS = {
  // Header dimensions
  HEADER_HEIGHT: 64, // px
  
  // Footer dimensions (includes padding and content)
  FOOTER_HEIGHT: 72, // px - estimated based on py-4 padding + button heights
  FOOTER_PADDING: 16, // py-4 = 16px top + 16px bottom
  
  // Audio player dimensions
  AUDIO_PLAYER_HEIGHT: 64, // px - estimated height when visible
  
  // Safety margins
  CONTENT_SAFETY_MARGIN: 16, // px - extra space to prevent content cutoff
  
  // Responsive breakpoints (matching Tailwind)
  MOBILE_BREAKPOINT: 768, // px
} as const;

// Helper functions for calculating dynamic heights
export const getFooterTotalHeight = (audioPlayerVisible: boolean = false): number => {
  let totalHeight = LAYOUT_CONSTANTS.FOOTER_HEIGHT;
  
  if (audioPlayerVisible) {
    totalHeight += LAYOUT_CONSTANTS.AUDIO_PLAYER_HEIGHT;
  }
  
  return totalHeight;
};

export const getContentPaddingBottom = (
  footerVisible: boolean = true,
  audioPlayerVisible: boolean = false,
  isMobile: boolean = false
): string => {
  if (!footerVisible) {
    // Base padding when footer is hidden
    return isMobile ? '5rem' : '6rem';
  }
  
  // Calculate total footer height
  const footerHeight = getFooterTotalHeight(audioPlayerVisible);
  const safetyMargin = LAYOUT_CONSTANTS.CONTENT_SAFETY_MARGIN;
  const totalPadding = footerHeight + safetyMargin;
  
  // Convert to rem (assuming 16px base font size)
  const paddingInRem = totalPadding / 16;
  
  return `${paddingInRem}rem`;
};
